exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".layout-158ef{min-height:100vh;overflow:hidden}*{text-overflow:ellipsis}", ""]);

// Exports
exports.locals = {
	"layout": "layout-158ef"
};